export default __webpack_public_path__ + "static/media/hero-bundle@3x.fd456b80.png";